import { compact } from "es-toolkit";

export function prefixedName(name: string, prefix: string | null | undefined): string {
  return compact([prefix, name]).join(".");
}
